import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';

import { ContentfulService } from './contentful.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  countries: { name: string; value: string; code: string }[] = [];
  constructor(private _http: HttpClient, private contentfulService: ContentfulService, private sandboxPageStateService: SandboxPageStateService) {
    const query = { 'fields.name': 'Country Menu#COMMON' };
    this.contentfulService.getMenuContentWithItems(query).then((items) => {
      this.countries = items[0]?.fields.jsonData;
    });
  }

  getCountries(): { name: string; value: string; code: string }[] {
    return this.countries;
  }

  getBaggagesDetails(): Observable<any> {
    return this._http.get('/assets/json/add-bagges-service-response/add-baggage-screen-response.xml', { responseType: 'text' });
  }

  getOfferPriceDetails(): Observable<any> {
    return this._http.get('/assets/json/offer-price-rs-xml.xml', { responseType: 'text' });
  }

  checkForUsersFirstVisit(featureName: string): boolean {
    let userId = this.sandboxPageStateService.getEncodedUserId();
    if (localStorage.getItem(featureName)) {
      return false;
    } else {
      return true;
    }
  }
}
